module.exports = require("serialize-error");


//////////////////
// WEBPACK FOOTER
// external "serialize-error"
// module id = 143
// module chunks = 0